import { render, staticRenderFns } from "./LpOrderProductCreate.vue?vue&type=template&id=28506e9a&scoped=true"
import script from "./LpOrderProductCreate.vue?vue&type=script&lang=js"
export * from "./LpOrderProductCreate.vue?vue&type=script&lang=js"
import style0 from "./LpOrderProductCreate.vue?vue&type=style&index=0&id=28506e9a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28506e9a",
  null
  
)

export default component.exports